var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 473 353",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 352.113v-1.096l169.829-166.532L83.061 0h188.81l33.528 79.27L380.688 0h91.768v90.71l-94.359 93.775 78.631 167.628H267.997l-24.272-58.811-58.258 58.811H0z"
  })));
}

export default SvgLogo;